import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const REVIEWS = [
    { name: "Marcus T.", handle: "@marcusbets", rating: 5, quote: "Hit the demon parlay 3 weeks straight. The pro picks alone paid for the year.", initials: "MT", color: "#a855f7" },
    { name: "Jasmine R.", handle: "@jaseplays", rating: 5, quote: "The free goblin slip is hotter than most paid services. Worth every penny.", initials: "JR", color: "#22c55e" },
    { name: "Dre L.", handle: "@dre_locks", rating: 5, quote: "Sports Premium is unreal. Two 50x cashes in a week. Devil cards FTW.", initials: "DL", color: "#ef4444" },
    { name: "Sam K.", handle: "@samkparlay", rating: 4, quote: "Risk badges are clutch. I know exactly when to ride a goblin and when to back off.", initials: "SK", color: "#3b82f6" },
    { name: "Olivia P.", handle: "@livplays", rating: 5, quote: "Clean UI, daily uploads on time, no Discord nonsense. Just picks. Love it.", initials: "OP", color: "#f97316" },
    { name: "Bryce H.", handle: "@brycehoops", rating: 5, quote: "Came for the goblin, stayed for the demons. NBA picks have been money.", initials: "BH", color: "#6f3fec" },
];

export const FanReviews = () => {
    return (
        <section className="relative pp-bg-1 py-16 sm:py-20" data-testid="fan-reviews-section">
            <div className="max-w-6xl mx-auto px-4 sm:px-6">
                <motion.div
                    initial={{ opacity: 0, y: 12 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="mb-8"
                >
                    <p className="text-xs font-mono uppercase text-[#a855f7] tracking-widest">What players say</p>
                    <h2 className="font-display text-3xl sm:text-4xl tracking-wider text-white">FAN REVIEWS</h2>
                </motion.div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {REVIEWS.map((r, i) => (
                        <motion.article
                            key={i}
                            initial={{ opacity: 0, y: 14 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: i * 0.05 }}
                            className="pp-bg-0 rounded-xl border border-[#242436] p-5 relative"
                            style={{ boxShadow: `0 0 0 1px ${r.color}22, 0 0 18px ${r.color}18` }}
                            data-testid={`review-card-${i}`}
                        >
                            <Quote className="absolute right-4 top-4 w-6 h-6" style={{ color: r.color, opacity: 0.4 }} />
                            <div className="flex items-center gap-3">
                                <div
                                    className="w-10 h-10 rounded-full flex items-center justify-center font-bold text-white"
                                    style={{ background: r.color }}
                                >
                                    {r.initials}
                                </div>
                                <div>
                                    <p className="text-sm font-semibold text-white">{r.name}</p>
                                    <p className="text-xs text-[#8b8ba0] font-mono">{r.handle}</p>
                                </div>
                            </div>
                            <div className="mt-3 flex items-center gap-0.5">
                                {Array.from({ length: 5 }).map((_, idx) => (
                                    <Star key={idx} className={`w-4 h-4 ${idx < r.rating ? "text-[#facc15] fill-[#facc15]" : "text-[#3a3a55]"}`} />
                                ))}
                            </div>
                            <p className="mt-3 text-sm text-[#b7b7c6] leading-relaxed">“{r.quote}”</p>
                        </motion.article>
                    ))}
                </div>
            </div>
        </section>
    );
};
